import cookie from '../../lib/cookie'
import CONSTANT from '../../constant/cookie'
import load from 'load-script'

const SDK = "https://hm.baidu.com/hm.js?156630aecfa146421847725a04f6e47c"
const setup = () => {
  var _hmt = _hmt || [];
  load(SDK, (err, script) => {
    if(err) {
      return console.warning('tongji sdk load fail.')
    }
    // 设置自定义变量
    setLoginTrack()
  })
    // (function() {
    //   var hm = document.createElement("script");
    //   hm.src = "https://hm.baidu.com/hm.js?156630aecfa146421847725a04f6e47c";
    //   var s = document.getElementsByTagName("script")[0]; 
    //   s.parentNode.insertBefore(hm, s);
    // })();
}
const setLoginTrack = () => {
  const userId = '' + cookie(CONSTANT.COOKIE_USER_ID)
  if(window._hmt && userId) {
    // 自定义变量的作用范围。该项可选。1为访客级别（对该访客始终有效），2为访次级别（在当前访次内生效），3为页面级别（仅在当前页面生效）。默认为3。
    _hmt.push(['_setCustomVar', 1, 'customer', userId, 3]);
  }
}

setup()